(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["regional-amazon-message"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    /*
      No automatic regions are enabled while this set is empty.
      Add ISO region codes here whenever regional mode should be re-enabled.
    */
    var MESSAGE_REGIONS = new Set([]);

    /*
      The alternate experience ends at 12:00 a.m. Eastern Time
      at the beginning of September 8, 2026.
    */
    var CAMPAIGN_END = Date.parse('2026-09-08T00:00:00-04:00');

    var ACTIVE_CLASS = 'regional-amazon-active';
    var MESSAGE_SELECTOR = '[data-regional-amazon-message]';
    var TARGET_HIDDEN_CLASS = 'regional-amazon-target-hidden';
    var root = document.documentElement;
    var currentMode = false;

    function normalizeRegion(value) {
      return String(value || '')
        .toUpperCase()
        .replace(/[^A-Z0-9]/g, '');
    }

    function getMessages() {
      return Array.prototype.slice.call(
        document.querySelectorAll(MESSAGE_SELECTOR)
      );
    }

    function clearExplicitTargets() {
      Array.prototype.slice.call(
        document.querySelectorAll('.' + TARGET_HIDDEN_CLASS)
      ).forEach(function (element) {
        element.classList.remove(TARGET_HIDDEN_CLASS);
      });
    }

    function hideExplicitTargets(messages) {
      messages.forEach(function (message) {
        var selector = message.getAttribute('data-regional-amazon-target');

        if (!selector) {
          return;
        }

        try {
          Array.prototype.slice.call(
            document.querySelectorAll(selector)
          ).forEach(function (element) {
            element.classList.add(TARGET_HIDDEN_CLASS);
          });
        } catch (error) {
          /* Invalid selectors are ignored so the storefront stays usable. */
        }
      });
    }

    function setRegionalAmazonMode(active) {
      var messages = getMessages();

      currentMode = Boolean(active);
      root.classList.toggle(ACTIVE_CLASS, currentMode);
      clearExplicitTargets();

      messages.forEach(function (message) {
        message.hidden = !currentMode;
        message.setAttribute(
          'aria-hidden',
          currentMode ? 'false' : 'true'
        );
      });

      if (currentMode) {
        hideExplicitTargets(messages);
      }

      document.dispatchEvent(
        new CustomEvent('regionalAmazonModeChanged', {
          detail: { active: currentMode }
        })
      );
    }

    function applyDetectedRegion() {
      var region = '';

      try {
        region = normalizeRegion(
          window.Shopify.customerPrivacy.getRegion()
        );
      } catch (error) {
        /* Unknown or failed detection leaves the storefront normal. */
        setRegionalAmazonMode(false);
        return;
      }

      setRegionalAmazonMode(MESSAGE_REGIONS.has(region));
    }

    function loadRegion() {
      if (
        window.Shopify &&
        window.Shopify.customerPrivacy &&
        typeof window.Shopify.customerPrivacy.getRegion === 'function'
      ) {
        applyDetectedRegion();
        return;
      }

      if (
        window.Shopify &&
        typeof window.Shopify.loadFeatures === 'function'
      ) {
        window.Shopify.loadFeatures(
          [
            {
              name: 'consent-tracking-api',
              version: '0.1'
            }
          ],
          function (error) {
            if (
              error ||
              !window.Shopify.customerPrivacy ||
              typeof window.Shopify.customerPrivacy.getRegion !== 'function'
            ) {
              setRegionalAmazonMode(false);
              return;
            }

            applyDetectedRegion();
          }
        );

        return;
      }

      /* API unavailable: leave the storefront normal. */
      setRegionalAmazonMode(false);
    }

    function getPreviewOverride() {
      var value;

      try {
        value = new URLSearchParams(window.location.search).get(
          'regional_amazon_preview'
        );
      } catch (error) {
        return null;
      }

      if (value === '1') {
        return true;
      }

      if (value === '0') {
        return false;
      }

      return null;
    }

    function scheduleCampaignEnd() {
      var delay = CAMPAIGN_END - Date.now();

      if (delay > 0 && delay <= 2147483647) {
        window.setTimeout(function () {
          setRegionalAmazonMode(false);
        }, delay);
      }
    }

    function initializeRegionalAmazonMessage() {
      var previewOverride = getPreviewOverride();

      /* Normal is always the safe default. */
      setRegionalAmazonMode(false);

      if (Date.now() >= CAMPAIGN_END) {
        return;
      }

      if (previewOverride !== null) {
        setRegionalAmazonMode(previewOverride);
        scheduleCampaignEnd();
        return;
      }

      /* Keep the theme editor usable unless preview mode is forced. */
      if (window.Shopify && window.Shopify.designMode) {
        return;
      }

      loadRegion();
      scheduleCampaignEnd();
    }

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        initializeRegionalAmazonMessage,
        { once: true }
      );
    } else {
      initializeRegionalAmazonMessage();
    }

    /* Re-apply the current mode when Shopify dynamically reloads a section. */
    document.addEventListener('shopify:section:load', function () {
      setRegionalAmazonMode(currentMode);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
